import { storyblokEditable } from '@storyblok/react'
import * as GridLayout from '@/components/GridLayout/GridLayout'
import { ProductPurchase } from '@/components/ProductPurchase/ProductPurchase'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'

type ProductPurchaseBlockProps = SbBaseBlockProps<{
  products: Array<string>
  productByline?: string
  preSelectFirstProduct?: boolean
  campaignCode?: string
  ribbonText?: string
}>

export const ProductPurchaseBlock = ({ blok, nested }: ProductPurchaseBlockProps) => {
  return (
    <GridLayout.Root {...storyblokEditable(blok)} nested={nested}>
      <GridLayout.Content width="1" align="center">
        <ProductPurchase
          products={blok.products}
          productByline={blok.productByline}
          preSelectFirstProduct={blok.preSelectFirstProduct}
          ribbonText={blok.ribbonText}
          nested={nested}
          campaignCode={blok.campaignCode}
        />
      </GridLayout.Content>
    </GridLayout.Root>
  )
}
